var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"saveAction":_vm.createDispatch,"title":_vm.$t(_vm.title),"id":_vm.id,"deleteAction":false,"actionButtons":true,"size":"md","closeButton":_vm.hide},on:{"shown":_vm.shown,"hidden":_vm.hidden}})}
var staticRenderFns = []

export { render, staticRenderFns }